import axios from 'axios';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import useMobile from '../hooks/useIsMobile';
import { Link } from 'react-router-dom';

const News = () => {
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMobile();

  const getNews = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`http://api.kwiecinscy.com.pl/api/news`);
      setNews(res.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  if (news.length > 0)
    return (
      <>
        <div className="container">
          <div className="flex flex-col relative items-center">
            <h1 className="text-[#0e3a1b] text-center uppercase">
              Aktualności
            </h1>
            <Link
              to="/aktualnosci"
              className="text-red-800 underline font-bold italic"
            >
              czytaj wszystkie aktualności
            </Link>
          </div>
        </div>
        <div className="flex gap-4 mt-6 mb-8 pb-8 justify-center border-b border-x-slate-900 mx-2">
          {news.map((article, index) => {
            const maxIndex = isMobile ? 1 : 3;
            if (index < maxIndex)
              return (
                <article
                  key={index}
                  className="flex flex-1 flex-col gap-2 hover:bg-slate-50 transition-all article rounded-2xl md:h-[450px] p-4 w-auto md:max-w-[500px]"
                >
                  <img
                    src={article.image}
                    alt={article.name}
                    className="object-cover w-full h-[50%] rounded-2xl"
                  />
                  <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-2">
                    <h3 className="text-[#0e3a1b] md:truncate">
                      {article.name}
                    </h3>
                    <span>{format(article.created_at, 'dd.MM.yyyy')}</span>
                  </div>
                  <span className="text-base">
                    {article.description.length >= 160
                      ? `${article.description.slice(0, 160)}...`
                      : article.description}
                  </span>
                  <Link
                    to="/aktualnosci"
                    className="mt-auto mx-auto bg-[#0e3a1b] hover:bg-[#235431] text-white px-8 py-1 rounded-3xl"
                  >
                    Czytaj więcej
                  </Link>
                </article>
              );
          })}
        </div>
      </>
    );
};

export default News;
